import * as bannersApi from '@/api/banners/banners'

const banners = {
  state: {
  },
  mutations: {
  },
  actions: {
    getBanners ({ commit }, data) {
      return new Promise((resolve, reject) => {
        bannersApi.getBanners(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    showBanner ({ commit }, data) {
      return new Promise((resolve, reject) => {
        bannersApi.showBanner(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
    updateBanner ({ commit }, data) {
      return new Promise((resolve, reject) => {
        bannersApi.updateBanner(data).then(res => {
          if (res.code === 2000) {
            resolve(res.data)
          } else {
            reject(res.message)
          }
        })
      })
    },
  }
}

export default banners
